import { useState, useEffect } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { filtrarEspecialidadesVigentes, mapEspecialidadesToText, filtrarPrestadoresVigentes, mapPrestadoresToText } from "./HorariosPrestadores-Utils";

export const useHorariosPrestadores = (mostrarNotificacion, history) => {
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [urlAxioPP, setUrlAxio] = useState("");
  const [tituloPagina, setTituloPagina] = useState("");
  const [especialidades, setEspecialidades] = useState([]);
  const [prestadores, setPrestadores] = useState([]);
  const [listadoPrestadores, setListadoPrestadores] = useState([]);
  const [especialidadSeleccionada, setEspecialidadSeleccionada] = useState(-1);
  const [prestadorSeleccionado, setPrestadorSeleccionado] = useState(-1);
  const [abrirDesplegableEspecialidades, setAbrirDesplegableEspecialidades] = useState(false);
  const [horario, setHorario] = useState([]);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });

  const traerHorariosPrestador = async (prestador) => {
    let horarios = null;
    const config = { headers: { Authorization: `Bearer ${usuario.token}` } };
    try {
      if (prestador !== -1) {
        const response = await axios.get(`${urlAxioPP}PrestadoresHorarios/${prestador}`, config);
        horarios = response.data.length !== 0 ? response.data[0] : [];
        setHorario(horarios);
      }
    } catch (e) {
      mostrarNotificacion(true, "Ha ocurrido un error al intentar cargar los horarios del prestador", "rojo");
    }
  };

  const traerHorariosEspecialidad = async (prestadores) => {
    let arrayHorarios = [];
    let arrayHorariosMostrar = [];
    const config = { headers: { Authorization: `Bearer ${usuario.token}` } };
    try {
      if (prestadores.length > 0) {
        const response = await axios.get(`${urlAxioPP}PrestadoresHorarios`, config);
        if (response.data.length > 0) {
          arrayHorarios = response.data.map((horario) => {
            for (const key in horario) {
              if (horario.hasOwnProperty(key) && typeof horario[key] === "string" && horario[key].startsWith("De ")) {
                horario[key] = horario[key].replace("De ", "");
              }
            }
            return horario;
          });
          arrayHorarios.forEach((horario) => {
            prestadores.forEach((prestador) => {
              if (prestador.codigo === horario.prestador) arrayHorariosMostrar.push(horario);
            });
          });
        } else {
          arrayHorarios = [];
        }
        setHorario(arrayHorariosMostrar);
      }
    } catch (e) {
      mostrarNotificacion(true, "Ha ocurrido un error al intentar cargar los horarios del prestador", "rojo");
    }
  };

  const traerEspecialidades = async (paciente) => {
    let especialidades = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = { headers: { Authorization: `Bearer ${paciente.token}` } };
    try {
      const response = await axios.get(`${url}Especialidades`, config);
      especialidades = response.data.length !== 0 ? response.data : [];
      especialidades = filtrarEspecialidadesVigentes(especialidades);
      especialidades = mapEspecialidadesToText(especialidades);
      setEspecialidades(especialidades);
    } catch (e) {
      mostrarNotificacion(true, "Ha ocurrido un error al intentar cargar las especialidades registradas", "rojo");
    }
  };

  const traerPrestadores = async (paciente) => {
    let prestadores = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = { headers: { Authorization: `Bearer ${paciente.token}` } };
    try {
      const response = await axios.get(`${url}Prestadores?mutuales=${paciente.mutual}`, config);
      prestadores = response.data.length !== 0 ? response.data : [];
      prestadores = filtrarPrestadoresVigentes(prestadores);
      let edad = dayjs(dayjs()).diff(paciente.nacimiento, "year");
      prestadores = prestadores.filter((prestador) => {
        if (prestador.filtroEdad) {
          if (prestador.edadDesde <= edad && edad <= prestador.edadHasta) return prestador;
        } else {
          return prestador;
        }
      });
      prestadores = mapPrestadoresToText(prestadores);
      setPrestadores(prestadores);
      setListadoPrestadores(prestadores);
    } catch (e) {
      mostrarNotificacion(true, "Ha ocurrido un error al intentar cargar los/las prestadores/as registrados/as", "rojo");
    }
  };

  const CargarDesplegables = async (sesion) => {
    await traerPrestadores(sesion);
    await traerEspecialidades(sesion);
  };

  const handleChangeSelect = (value, select) => {
    setCargando(true);
    switch (select) {
      case "Especialidad":
        setHorario([]);
        setEspecialidadSeleccionada(value);
        if (value !== -1) {
          let arrayPrestadores = prestadores.filter(
            (prestador) =>
              prestador.especialidad === value ||
              prestador.especialidad2 === value ||
              prestador.especialidad3 === value
          );
          setListadoPrestadores(arrayPrestadores);
          traerHorariosEspecialidad(arrayPrestadores);
        } else {
          setListadoPrestadores(prestadores);
          setPrestadorSeleccionado(-1);
        }
        break;
      default:
        mostrarNotificacion(true, "Seleccion invalida", "rojo");
        break;
    }
    setCargando(false);
  };

  const handleClickReservarTurnoPrestador = (prestador) => {
    history.push({
      pathname: "/portal/Reservar turno",
      state: { prestador: prestador },
    });
  };

  // useEffect para inicializar el componente al montarse
  useEffect(() => {
    const inicializar = async () => {
      setCargando(true);
      try {
        const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
        const url = localStorage.getItem("urlAxioPP");
        const titulo = localStorage.getItem("tituloWeb");
        
        if (sesion && url) {
          setUsuario(sesion);
          setUrlAxio(url);
          setTituloPagina(titulo || "Horarios de Atención");
          
          // Cargar especialidades y prestadores
          await CargarDesplegables(sesion);
        } else {
          mostrarNotificacion(true, "No se encontró sesión activa", "rojo");
          history.push("/Login");
        }
      } catch (e) {
        console.error("Error al inicializar HorariosPrestadores:", e);
        mostrarNotificacion(true, "Error al cargar los datos iniciales", "rojo");
      } finally {
        setCargando(false);
      }
    };
    
    inicializar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    usuario, setUsuario,
    cargando, setCargando,
    urlAxioPP, setUrlAxio,
    tituloPagina, setTituloPagina,
    especialidades, setEspecialidades,
    prestadores, setPrestadores,
    listadoPrestadores, setListadoPrestadores,
    especialidadSeleccionada, setEspecialidadSeleccionada,
    prestadorSeleccionado, setPrestadorSeleccionado,
    abrirDesplegableEspecialidades, setAbrirDesplegableEspecialidades,
    horario, setHorario,
    toast, setToast,
    traerHorariosPrestador,
    traerHorariosEspecialidad,
    traerEspecialidades,
    traerPrestadores,
    CargarDesplegables,
    handleChangeSelect,
    handleClickReservarTurnoPrestador,
  };
};
